export const MINUTE_OPTIONS_15 = ["00", "15", "30", "45"];
